module.exports = __webpack_public_path__ + "img/copy.c3d73139.svg";